import * as React from "react";
import PropTypes from "prop-types";
// import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Stack, Avatar, IconButton } from "@mui/material";

import LockIcon from "@mui/icons-material/Lock";
import {
  fullName,
  getErrorString,
  getUserId,
  isOwner,
  truncate,
} from "./../../constants/function";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import ApiService from "./../../services/api-service";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import NoData from "./../../components/Nodata";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Images } from "./../../assets/common";
import Chips from "../../components/Chips";
import TopBanner from "../../components/TopBanner";
import { useDispatch, useSelector } from "react-redux";
import { addSongAction, addSongsAction } from "./../../action/songs";
import DropMenu from "../../components/DropMenu";
import OutsideClickHandler from "react-outside-click-handler";
import NftCard from "../../components/NftCard";
import { useTranslation } from "react-i18next";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Nft() {
  const { t } = useTranslation("common");
  const songs = useSelector((state) => state.songs);
  const [loader, setLoader] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedId, setSelectedId] = React.useState(null);
  const dispatch = useDispatch();
  const [show, setShow] = React.useState(false);
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const userId = getUserId();
  const { tab } = useParams();
  const [pageNo, setPageno] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const [loading, setLoading] = React.useState(false);
  const [nft, setNft] = React.useState([]);
  const [playlistNft, setPlaylistNft] = React.useState([]);

  //User nft
  const getUserNft = async (tab, activeTab, next, list) => {
    try {
      setLoading(true);
      const response =
        tab === 0
          ? await ApiService.USER_NFT_MUSIC({
              userId: userId,
              pageSize: 16,
              pageNo: next,
            })
          : await ApiService.USER_NFT_PLAYLIST({
              userId: userId,
              pageSize: 16,
              pageNo: next,
            });

      if (tab === 0) {
        if (list.length === 0) {
          setNft([...response["result"]]);
          setPlaylistNft([]);
        } else setNft([...nft, ...response["result"]]);
      } else {
        if (list.length === 0) {
          setPlaylistNft([...response["result"]]);
          setNft([]);
        } else setPlaylistNft([...playlistNft, ...response["result"]]);
      }
      setLoaded(response["result"].length < 16 ? true : false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  React.useEffect(() => {
    setValue(!tab || tab === "music" ? 0 : 1);
    getUserNft(!tab || tab === "music" ? 0 : 1, tab, pageNo, []);
  }, [tab]);
  const addSong = async (nft, isPlaylist) => {
    if (!isPlaylist) dispatch(addSongAction(nft["musicDetails"]));
    else if (
      isPlaylist &&
      nft["playlistDetails"] &&
      nft["playlistDetails"]["music"].length > 0
    ) {
      const music = await getPlayListMusic(nft["playlistDetails"]["_id"]);

      dispatch(addSongsAction(music, false, nft["playlistDetails"]["_id"], 0));
    }
  };
  const getPlayListMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: 1,
        pageSize: 16,
      });

      setLoading(false);

      return response["result"]["music"];
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Playlist has no music")
        notifier.error(getErrorString(error));
      return [];
    }
  };
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageno(next);
      getUserNft(value, tab, next, value === 0 ? nft : playlistNft);
    }
  };
  React.useEffect(() => {
    const d = document.getElementById("__app_container");
    // d[0].style.overflow = "unset !important";
    d.classList.add("noScroll");
    return () => {
      const d = document.getElementById("__app_container");
      // d[0].style.overflow = "scroll";
      d.classList.remove("noScroll");
      setNft([]);
      setPlaylistNft([]);
    };
  }, []);

  const handleOpenGift = (index, type) => {
    setSelectedIndex(index);
    setLoader(true);
    updateGiftStatus(type, index);
  };
  const updateGiftStatus = async (type, index) => {
    try {
      const nftData = type === "musicNFT" ? nft : playlistNft;
      const response = await ApiService.updatGiftStatus({
        type: type,
        assetId: type === "musicNFT" ? nftData[index]._id : nftData[index].id,
      });
      setLoader(false);
      setSelectedIndex(null);
      nftData[index].opening = true;
      if (type === "musicNFT") setNft([...nftData]);
      else setPlaylistNft([...nftData]);

      setTimeout(() => {
        notifier.success(response.result);
        nftData[index].isOpened = true;
        if (type === "musicNFT") setNft([...nftData]);
        else setPlaylistNft([...nftData]);
      }, 3000);
    } catch (error) {}
  };
  return (
    <Box
      className="__main_pading"
      sx={
        {
          // bgcolor: "background.default"
          // backgroundColor: "#090909",
        }
      }
    >
      {location.pathname === "/app/TopNft" ? (
        <Box>
          <Box
            sx={{
              color: "#999999",
              display: "flex",
              alignItems: "center",
              padding: "0 20px 20px 0px",
            }}
            className="_cp fs-14"
            onClick={() => history.goBack()}
          >
            <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} />{" "}
            Back
          </Box>

          <TopBanner />
        </Box>
      ) : (
        <Stack
          direction="row"
          spacing={1}
          overflow="scroll"
          style={{
            position: "sticky",
            top: "0",
            zIndex: "1",
            // backgroundColor: "#1e1e1e",
            // backgroundColor: "#090909",
            padding: "10px 0 10px  0",
          }}
        >
          {[t("myCollection.tabs.tab1"), t("myCollection.tabs.tab2")].map(
            (label, index) => (
              <Chips
                key={index}
                label={label}
                index={index}
                activeTab={value}
                handleClick={(tab) => {
                  setPageno(0);
                  history.push(`/app/Nft/${tab === 0 ? "music" : "studio"}`);
                }}
              />
            )
          )}
        </Stack>
      )}

      <Box
        sx={{
          // bgcolor: "background.default",
          // bgcolor: "#090909",
          padding: "0 0 100px 0 !important",
          height: `calc(100vh - ${
            songs["songs"].length > 0 ? "190px" : "120px"
          })`,
        }}
        index={value}
        // onClick={handleChangeIndex}
      >
        <Stack
          className="__card_container"
          position="relative"
          onScroll={(e) => handleScroll(e.target)}
          sx={{
            paddingBottom: "60px",
            maxHeight: `${songs["songs"].length > 0 ? "72vh" : "84vh"}`,
            overflow: "scroll",
          }}
        >
          {nft.length > 0 && tab === "music" ? (
            nft.map((nft, index) => (
              <Box className="__nft_music_card" key={index}>
                {(nft.isOpened && nft.gift) || !nft.gift ? (
                  <NftCard nft={nft} />
                ) : (
                  <Box
                    sx={{ position: "relative" }}
                    title="Click to open your gift"
                    className="_cp _nft_list_gift_card"
                    onClick={() => handleOpenGift(index, "musicNFT")}
                  >
                    {loader && selectedIndex === index ? (
                      <Loader _class="__loader_inside" />
                    ) : null}
                    <img
                      src={
                        !nft.isOpened && !nft.opening
                          ? Images.gift_closed
                          : Images.gift_open
                      }
                      alt=""
                    />
                  </Box>
                )}
                {(nft.isOpened && nft.gift) || !nft.gift ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    marginTop="5px"
                  >
                    <Stack>
                      <Typography
                        className="fs-16 "
                        title={nft?.musicDetails?.title}
                      >
                        {truncate(nft?.musicDetails?.title, 20)}
                      </Typography>

                      {nft["owner"] ? (
                        <Typography className="fs-14 fade-text">
                          {fullName(nft["owner"])}
                        </Typography>
                      ) : null}
                    </Stack>
                    {nft["private"] ? (
                      <LockIcon className="__small_icon __private" />
                    ) : null}
                  </Stack>
                ) : null}
                {/* {nft["onSale"] ? (
                  <Stack direction="column" spacing={1}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Stack direction="row" spacing={1} alignItems="center">
                        <img
                          style={{ width: "18px" }}
                          src={Images.listen_yellow}
                          alt="listen"
                        />
                        <Typography className="fs-14" sx={{ color: "#FFB715" }}>
                          {nft?.musicDetails?.listens}
                        </Typography>
                      </Stack>
                      <Stack direction="row" alignItems="center">
                        <img
                          style={{ width: "18px" }}
                          src={Images.tip_blue}
                          alt="listen"
                        />
                        <Typography
                          className="fs-14"
                          sx={{ color: "#62FFE1 !important" }}
                        >
                          $ {(nft?.sellingPrice * 0.05).toFixed(2)}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Box
                      sx={{
                        background: "#343434",
                        borderRadius: "6px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography className="fs-14 text-white">
                        On Sale
                      </Typography>
                    </Box>
                  </Stack>
                ) : null} */}
              </Box>
            ))
          ) : (
            <Box
              onScroll={(e) => handleScroll(e.target)}
              sx={{
                maxHeight: `${songs["songs"].length > 0 ? "72vh" : "90vh"}`,
                overflow: "scroll",
              }}
              spacing={1}
              className="__card_container"
            >
              {playlistNft.length > 0 && tab === "studio" ? (
                playlistNft.map((p, index) => (
                  <Box
                    className="__music_card"
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   history.push(`/app/SellAuctionPlayList/${p["_id"]}`);
                    //   // addSong(p, true);
                    // }}
                    key={p["_id"]}
                  >
                    {!p.isOpened && p.gift ? (
                      <Box
                        sx={{ position: "relative" }}
                        title="Click to open your gift"
                        className="_cp _nft_list_gift_card_playlist"
                        onClick={() => handleOpenGift(index, "playlistNFT")}
                      >
                        {loader && selectedIndex === index ? (
                          <Loader _class="__loader_inside" />
                        ) : null}

                        <img
                          src={
                            !p.isOpened && !p.opening
                              ? Images.gift_closed
                              : Images.gift_open
                          }
                          alt=""
                        />
                      </Box>
                    ) : (
                      <>
                        <Stack sx={{ position: "relative" }}>
                          <img
                            className="__music_Card_image"
                            src={
                              p["playlistDetails"] &&
                              p["playlistDetails"]["GIF"] &&
                              p["playlistDetails"]["GIF"]["filePath"]
                                ? p["playlistDetails"]["GIF"]["filePath"]
                                : p["playlistDetails"] &&
                                  p["playlistDetails"]["thumbnailImg"] &&
                                  p["playlistDetails"]["thumbnailImg"][
                                    "filePath"
                                  ]
                                ? p["playlistDetails"]["thumbnailImg"][
                                    "filePath"
                                  ]
                                : Images.album
                            }
                            onClick={(e) => {
                              //console.log("move to details");
                              e.stopPropagation();
                              // history.push(
                              //   `/app/SellAuctionPlayList/${p["_id"]}`
                              // );
                              //console.log(p);
                              history.push(`/app/Music/${p["id"]}`);
                            }}
                            alt="rectangle"
                          />
                          <Box
                            className="__options"
                            sx={{
                              position: "absolute",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "210px",
                              height: "210px",
                              top: 0,
                            }}
                          >
                            <IconButton
                              onClick={(e) => {
                                // e.stopPropagation();
                                // addSong(p, true);
                                history.push(`/app/Music/${p["id"]}`);
                              }}
                            >
                              <img src={Images.play} alt="play" />
                            </IconButton>
                            <IconButton
                              className="__more_hover"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedId(p["_id"]);
                                setShow(!show);
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </Box>
                          {!p.platform ? null : p.platform === "Hedera" ? (
                            <img
                              title={t("dropMenu.m23")}
                              onClick={() =>
                                history.push(
                                  `/app/PlaylistNftDetail/${p["_id"]}`
                                )
                              }
                              style={{
                                position: "absolute",
                                width: "30px",
                                left: "6px",
                                bottom: "8px",
                              }}
                              src={Images.hbar_2}
                              alt="nft"
                            />
                          ) : p.platform === "Polygon" ? (
                            <img
                              title={t("dropMenu.m23")}
                              onClick={() =>
                                history.push(
                                  `/app/PlaylistNftDetail/${p["_id"]}`
                                )
                              }
                              style={{
                                position: "absolute",
                                width: "30px",
                                left: "6px",
                                bottom: "8px",
                              }}
                              src={Images.polygoon2}
                              alt="polygon"
                            />
                          ) : (
                            <img
                              title={t("dropMenu.m23")}
                              onClick={() =>
                                history.push(
                                  `/app/PlaylistNftDetail/${p["_id"]}`
                                )
                              }
                              style={{
                                position: "absolute",
                                width: "30px",
                                left: "6px",
                                bottom: "8px",
                              }}
                              src={Images.near_nft}
                              alt="near"
                            />
                          )}

                          {show && p["_id"] === selectedId ? (
                            <OutsideClickHandler
                              onOutsideClick={() => setShow(false)}
                            >
                              <DropMenu
                                actions={[
                                  { key: "m23", action: t("dropMenu.m23") },
                                ]}
                                toggleMenu={() =>
                                  history.push(
                                    `/app/PlaylistNftDetail/${p["_id"]}`
                                  )
                                }
                              />
                            </OutsideClickHandler>
                          ) : null}
                        </Stack>

                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-start"
                          marginTop="5px"
                        >
                          <Stack>
                            <Typography className="fs-16 ">
                              {p?.playlistDetails?.title}
                            </Typography>

                            {p["owner"] ? (
                              <Typography className="fs-14 fade-text">
                                {fullName(p["owner"])}
                              </Typography>
                            ) : null}
                          </Stack>
                          {p["private"] ? (
                            <LockIcon className="__small_icon __private" />
                          ) : null}
                        </Stack>

                        {p["onSale"] ? (
                          <Stack direction="column" spacing={1}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <img
                                  style={{ width: "18px" }}
                                  src={Images.people}
                                  alt="listen"
                                />
                                <Typography
                                  className="fs-14"
                                  sx={{ color: "#FFB715" }}
                                >
                                  {p?.playlistDetails?.listens}
                                </Typography>
                              </Stack>
                              <Stack direction="row" alignItems="center">
                                <img
                                  style={{ width: "18px" }}
                                  src={Images.tip_blue}
                                  alt="listen"
                                />
                                <Typography
                                  className="fs-14"
                                  sx={{ color: "#62FFE1 !important" }}
                                >
                                  $ {(p?.sellingPrice * 0.05).toFixed(2)}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                        ) : null}
                      </>
                    )}
                  </Box>
                ))
              ) : (
                <NoData
                  lable={`${t("noData.message15")} ${
                    value === 0 ? "music" : "studio"
                  }  ${t("noData.message18")}`}
                />
              )}
            </Box>
            // <NoData lable="No music NFT available" />
          )}
        </Stack>
      </Box>
      {loading ? <Loader /> : null}
    </Box>
  );
}
